import React from 'react';
import type { FCWithChildren } from '../../../types/FCWithChildren';

// This wraps the table component to provide some nice padding, rounded corners, and other TW styles.
// This is the default "look" of the new tables.
export const TableCard: FCWithChildren = ({ children }) => {
  return (
    <div className="mt-2 flow-root">
      <div className="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
        <div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
          <div className="overflow-hidden shadow ring-1 ring-black ring-opacity-5 sm:rounded-lg">
            <table className={'min-w-full divide-y divide-gray-300'}>{children}</table>
          </div>
        </div>
      </div>
    </div>
  );
};
